// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"142":"dfb7b10a","787":"d4c10e0b","971":"694fc0cc"}[chunkId] + ".chunk.js";
};